<template>
  <v-dialog persistent v-model="dialog" width=60%>
    <v-card>
      <v-card-title class="px-2">
        Bookings with damage claims assigned to you
      </v-card-title>
      <!-- data tabel goes here -->
      <v-row no-gutters class="row-default">
        <v-col cols="12" class="px-2">
          <v-data-table class="elevation-1" dense :headers="getHosmHeaders()" :items="assigned_claims"
            :disable-pagination=true hide-default-footer item-key="activity">
            <template v-slot:item="claim">
              <tr>
                <td>{{ claim.item.claim }}</td>
                <td class="row-pointer" v-on:click="openHuov(claim.item.huov_encrid)">{{ claim.item.booking }}</td>
                <td>{{ listArrayElements(claim.item.selected_smct) }}</td>
                <td>{{ claim.item.summary | max_char(50) }}</td>
                <td style="text-align:right">{{ claim.item.claimedAmount | prefix_euro }}</td>
                <td>{{ claim.item.hosm_smst_display }}</td>
                <td>
                  <div v-if="!!claim.item.attachments"> <!-- 0 = false; <> 0 = true -->
                    <v-badge color="grey lighten-2" overlap bordered offset-y="27" offset-x="17">
                      <template v-slot:badge>
                        <span>{{ claim.item.attachments }}</span> 
                      </template>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar v-bind="attrs" v-on="on" size="40" style="margin-top:8px;" class="row-pointer">
                            <v-icon small>mdi-paperclip</v-icon>
                          </v-avatar>
                        </template>
                        <span>Claim {{ claim.item.claim }} has {{ claim.item.attachments }} attachments</span>
                      </v-tooltip>
                    </v-badge>
                  </div>
                  <div v-else>
                    <v-btn x-small text icon disabled>
                      <v-icon small></v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
          <span class="br_medium"></span>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" small v-on:click="getAssignedClaims()">
          <v-icon left>mdi-reload</v-icon>Reload
        </v-btn>
        <v-btn color="primary" small v-on:click="closeDialog()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
  import mxmaxchar from '@/mixins/filtermaxchar';

  export default {
    components: {
    },
    mixins: [mxmaxchar],
    data() { 
        return {
            dialog: false,
            user: '',
            assigned_claims: []
        }
    },
    created() { // set up event bus listener here on created event

    },
    computed: {

    },
    filters: {
      prefix_euro(value) {
        if (value != '') {
          return "€ " + value;
        }
        else {
          return value;
        }
      }
    },
    methods: {
      open(user) {
        this.user = user;
        console.log(this.user);
        this.loading = false;
        this.getAssignedClaims();
      },
      getHosmHeaders() {
        return [
          { text: "Claim", value: "claim", sortable: false },
          { text: "Booking", value: "booking", sortable: false },
          { text: "Type", value: "booking", sortable: false },
          { text: "Summary", value: "summary", sortable: false },
          { text: "Amount", value: "claimedAmount", align: "end", sortable: false },
          { text: "Status", value: "hosm_smst_display", sortable: false },
          { sortable: false, align: "start" },
        ];
      },
      openHuov(param) {
        this.$router.open('/huov/onHuov/' + param);
      },
      listArrayElements(param) {
        return param.join();
      },
      getAssignedClaims() {
        this.$axios
          .post("ares/json/ares/syst/dashboard/getAssignedClaims.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "getAssignedClaims"
            },
            getAssignedClaims: {
              user: this.user
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.assigned_claims = res.data.getAssignedClaims;
            }
          })
          .finally(() => {
            this.loading = false;
            this.dialog = true;
          });
      },
      closeDialog() {
        this.dialog = false;
      },
    }
  }
</script>

<style scoped>
  .row-pointer {
    cursor: pointer;
  }
  .row-default {
    cursor: default;
  }
  .br_medium {
    display: block;
    margin-bottom: 1em;
  }
</style>
